import styled from 'styled-components';
import { ButtonBase } from '../ButtonBase';

export const StyledPrimaryButton = styled(ButtonBase)`
  background-color: ${(props): string => props.theme.colors.primary};
  color: ${(props): string => props.theme.colors.black};
  border-radius: 0;
  border: 1px solid ${(props): string => props.theme.colors.primary};
  align-items: center;

  // TODO: should use design token, add more specificity to override
  &.ant-btn.button-base {
    :hover,
    :focus,
    :active {
      background-color: ${(props): string => props.theme.colors.primary};
      color: ${(props): string => props.theme.colors.black};
      border-color: transparent;
    }

    :hover {
      background-color: ${(props): string => props.theme.colors.primaryHover};
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.04) 0%, rgba(0, 0, 0, 0.04) 100%),
        ${(props): string => props.theme.colors.primary};
    }

    :focus {
      color: ${(props): string => props.theme.colors.black};
      border-color: ${(props): string => props.theme.colors.focusBorder};
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.12) 100%),
        ${(props): string => props.theme.colors.primary};
    }

    :active {
      color: ${(props): string => props.theme.colors.black};
      border-color: ${(props): string => props.theme.colors.primary};
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.12) 0%, rgba(0, 0, 0, 0.12) 100%),
        ${(props): string => props.theme.colors.primary};
    }

    :disabled,
    :disabled:hover {
      border-color: ${(props): string => props.theme.colors.brightGrey};
      background-color: ${(props): string => props.theme.colors.brightGrey};
      color: ${(props): string => props.theme.colors.grey};
    }

    &.button--size-s {
      height: 32px;
      ${(props): string => props.theme.fontStyles.redesign.base.normal};
      padding: 6px ${(props): string => props.theme.spacing.base} 4px;
    }

    &.button--size-m {
      width: fit-content;
      height: 40px;
      ${(props): string => props.theme.fontStyles.redesign.lg.strong};
      padding: ${(props): string => props.theme.spacing.xs} ${(props): string => props.theme.spacing.base};
    }

    &.button--size-l {
      width: fit-content;
      height: ${(props): string => props.theme.spacing.xxl};
      ${(props): string => props.theme.fontStyles.redesign.lg.strong};
      padding: ${(props): string => props.theme.spacing.sm} ${(props): string => props.theme.spacing.md};
    }

    &.button--full-width {
      width: 100%;
    }
  }
`;
